import { render, staticRenderFns } from "./IryohokenDetails.vue?vue&type=template&id=ff5de8f2&"
import script from "./IryohokenDetails.vue?vue&type=script&lang=ts&"
export * from "./IryohokenDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports